export const SystemDashboardTabKeys = {
    orders: "orders",
    reports: "reports",
    briefs: "briefs",
    providers: "providers"
};

export const SystemDashboardTabKeysToName = {
    [SystemDashboardTabKeys.orders]: "ניהול הזמנות",
    [SystemDashboardTabKeys.reports]: "מרכז הדוחות",
    [SystemDashboardTabKeys.briefs]: "ניהול בריפים",
    [SystemDashboardTabKeys.providers]: "ספקים"
};
